import React, { use, useEffect, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import useLog from '../../../hooks/useLog';
import { useDispatch, useSelector } from 'react-redux';
import { setShowDoorLogsModal } from '../../../slice/showModalSlice';
import { setSelectedDoor } from '../../../slice/editDoorSlice';
import { getPeopleInside } from '../../../utils/logUtils';
import { getDateFormatted } from '../../../utils/dateUtils';
import { toast } from 'react-toastify';
import './doorLogsModal.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';

const DoorLogsModal = () => {

    const show = useSelector((state)=>state.showModal.showDoorLogsModal);
    const dispatch = useDispatch();
    const { logLoading, getOpenLogsIn24h, getUserInside, getHistoryLogs } = useLog();
    const door = useSelector((state)=>state.editDoor.selectedDoor);
    const [logs,setLogs] = useState(null);
    const [userInside,setUserInside] = useState([]);

    useEffect(()=>{
        if(door && show){
            getHistoryLogs(
                {startDate: new Date(Date.now() - 8 * 60 * 60 * 1000).getTime(),endDate: Date.now(),doorId: door.id,},
                (data)=>{
                    let last = data.find((element)=>element.type === "OPEN");
                    setLogs(last);
                },
                (error)=>{}
            )

            const idInt =  setInterval(()=>{
                    getHistoryLogs(
                        {startDate: new Date(Date.now() - 8 * 60 * 60 * 1000).getTime(),endDate: Date.now(),doorId: door.id,},
                        (data)=>{
                        let last = data.find((element)=>element.type === "OPEN");
                        setLogs(last);
                        },
                        (error)=>{
                            toast.error(typeof error === "string" ? error : "Errore nel recupero dei log");
                        }
                    )
                },10000)

            const idInt2 =  setInterval(()=>{
                    getUserInside(door.id,
                        (data)=>{
                            setUserInside(data);
                        },
                        (error)=>{
                            toast.error(typeof error === "string" ? error : "Errore nel recupero degli utenti all'interno");
                        }
                    )
                },3000)
    
            return () => {
                clearInterval(idInt);
                clearInterval(idInt2);
                setLogs(null);
                setUserInside([]);
            }
        }
        return undefined;
    },[door,show])

    const closeModal = () =>{
        dispatch(setShowDoorLogsModal());
    }

    //const peopleInside = getPeopleInside(logs);

  return (
      <Modal show={show} size="xl" backdrop={true}  onHide={closeModal}>
        <Modal.Header closeButton>
            <Modal.Title className='text-primary-custom'>Log Entrate</Modal.Title>
        </Modal.Header>
        <Modal.Body>
                        <div className='d-flex flex-column gap-3'>
                            <fieldset className='detail-fieldset flex-column gap-2 align-items-center w-100'>
                                <legend className="detail-legend">Info</legend>
                                <h5>Ultima Apertura:</h5>
                                {
                                    logs
                                    ?<div className='d-flex justify-content-between person-card'>
                                        <div className='d-flex align-items-center gap-2'>
                                            <FontAwesomeIcon icon={faUser}/>
                                            <p className='m-0 fw-bold'>{logs.username}</p>
                                        </div>
                                            <p className='m-0'>{getDateFormatted(logs.eventDate,"DD/MM/YY HH:mm")}</p>
                                    </div>
                                    :<p className='m-0'>Nessun utente ha aperto la porta</p>

                                }
                            </fieldset>
                            <fieldset className='detail-fieldset flex-column gap-2 align-items-center w-100'>
                                <legend className="detail-legend text-primary-custom">persone presenti in stanza: {userInside.length}</legend>
                                {
                                    userInside.length > 0
                                    ?<div className='d-flex flex-column align-items-center w-100 overflow-y-auto gap-2 max-h-overflow'>
                                        {
                                            userInside.map((person)=>(
                                                <div className='d-flex justify-content-between person-card'>
                                                    <div className='d-flex align-items-center gap-2'>
                                                        <FontAwesomeIcon icon={faUser}/>
                                                        <p className='m-0 fw-bold'>{person.username}</p>
                                                    </div>
                                                    <p className='m-0'>{getDateFormatted(person.date,"DD/MM/YY HH:mm")}</p>
                                                </div>
                                                )
                                            )
                                        }

                                    </div>
                                    :<p className='m-0'>Nessun utente all'interno</p>

                                }
                            </fieldset>
                        </div>
        </Modal.Body>
        <Modal.Footer>
            <div className='d-flex gap-2'>
                <Button variant="warning" onClick={closeModal}>Annulla</Button>
            </div>
        </Modal.Footer>
    </Modal>
  )
}

export default DoorLogsModal